import React from 'react';
import './HeroNew.css';
import { useComponentAnalytics } from '../hooks/useAnalytics';

const HeroNew = ({ onNavigate }) => {
  const { trackInteraction } = useComponentAnalytics('HeroNew');

  const handleCTAClick = (buttonType) => {
    trackInteraction('cta_click', 'button', {
      button_type: buttonType,
      button_location: 'hero_section'
    });
  };

  return (
    <section id="inicio" className="hero-new">
      <div className="hero-background">
        <div className="hero-grid"></div>
        <div className="hero-gradient"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title fade-in-up">
              <span className="hero-badge">🧠 ExpertMind</span>
              <br />
              Plataforma <span className="highlight">segura y escalable</span> 
              <br />de IA Corporativa
            </h1>
            <p className="hero-subtitle fade-in-up">
              Centraliza, estructura y controla el uso de inteligencia artificial en tu empresa. 
              Una solución basada en <span className="highlight-text">agentes configurables</span> que 
              transforma la información dispersa en decisiones inteligentes, con 
              <span className="highlight-text"> gobernanza empresarial</span> desde el primer día.
            </p>
            <div className="hero-actions fade-in-up">
              <a 
                href="#contacto" 
                className="btn btn-primary"
                onClick={() => handleCTAClick('demo_primary')}
              >
                <span>Solicitar Demo</span>
                <span className="btn-icon">→</span>
              </a>
              <button 
                className="btn btn-secondary"
                onClick={() => {
                  handleCTAClick('blog_secondary');
                  onNavigate('blog');
                }}
              >
                <span>Ver Blog</span>
                <span className="btn-icon">📖</span>
              </button>
            </div>
            <div className="hero-trust fade-in-up">
              <div className="trust-badges">
                <span className="trust-badge">🔒 Seguridad Empresarial</span>
                <span className="trust-badge">🎯 Gobernanza Integrada</span>
                <span className="trust-badge">⚡ IA Controlada</span>
              </div>
            </div>
          </div>
          
          <div className="hero-visual">
            <div className="hero-dashboard float">
              <div className="dashboard-header">
                <div className="dashboard-title">
                  <span className="dashboard-icon">🧠</span>
                  ExpertMind - Diferenciadores
                </div>
                <div className="dashboard-status">
                  <span className="status-dot active"></span>
                  <span>5 ventajas competitivas</span>
                </div>
              </div>
              <div className="dashboard-content">
                <div className="differentiators-list">
                  <div className="diff-item">
                    <span className="diff-icon">🛡️</span>
                    <div className="diff-text">
                      <strong>Gobernanza</strong>
                      <small>Ventaja Competitiva</small>
                    </div>
                  </div>
                  <div className="diff-item">
                    <span className="diff-icon">⚙️</span>
                    <div className="diff-text">
                      <strong>Eficiencia</strong>
                      <small>Operativa Multiplicada</small>
                    </div>
                  </div>
                  <div className="diff-item">
                    <span className="diff-icon">🔒</span>
                    <div className="diff-text">
                      <strong>Cumplimiento</strong>
                      <small>Mitigación de Riesgos</small>
                    </div>
                  </div>
                  <div className="diff-item">
                    <span className="diff-icon">📈</span>
                    <div className="diff-text">
                      <strong>Escalabilidad</strong>
                      <small>Con Gobernanza</small>
                    </div>
                  </div>
                  <div className="diff-item">
                    <span className="diff-icon">💡</span>
                    <div className="diff-text">
                      <strong>Transformación</strong>
                      <small>Datos a Decisiones</small>
                    </div>
                  </div>
                </div>
                <div className="dashboard-footer-link">
                  <a href="#diferenciadores">Ver detalles completos →</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroNew;
